import { defaultHttpClient } from './_HttpClient';
class CustomerLeftMenuClient {
    async GetCustomerLeftMenu(IsUnread) {
        const resp = await defaultHttpClient.post("/Ajax/MobileCmn.aspx/GetMyAccountLeftMeun", { IsUnread: IsUnread });
        const data = resp.data;
        return data.d;
    }
}
export const customerLeftMenuClient = new CustomerLeftMenuClient();
